export const environment = {
  production: true
};



// WEBPACK FOOTER //
// ./client/environments/environment.ts